import React from 'react';
import PropTypes from 'prop-types';
import { Box, Button, DialogTitle, DialogContent, DialogActions, Typography } from '@material-ui/core';

import { DialogButton, AlertWrapper } from 'src/components';
import { useFetchStatus } from 'src/hooks';


const AnalyticDeleteDialog = props => {

  const { actions, analytic } = props;

  const { fetchStatus, errorMessage, hasError, handleConfirm } = useFetchStatus({
    confirmFn: () => actions.deleteAnalytic(analytic.id),
    closeFn: actions.closeDialog,
  });

  return (
    <>
      <DialogTitle id="form-dialog-title">Eliminar analítica</DialogTitle>
      <DialogContent>
        <Box p={1}>
          <Typography variant="body1" color="textPrimary">
            Estás eliminando la analítica con título <strong>{`"${analytic.title}"`}</strong>
          </Typography>
          <br />
          <Typography variant="body1" color="textPrimary">
            ¿Realmente deseas eliminar la analítica?
          </Typography>
          <br />
          {hasError && <AlertWrapper severity="error">{errorMessage}</AlertWrapper>}
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={actions.closeDialog}>Cancelar</Button>
        <DialogButton fetchStatus={fetchStatus} onClick={handleConfirm} color="primary">Si, eliminar</DialogButton>
      </DialogActions>
    </>
  );
};

AnalyticDeleteDialog.propTypes = {
  analytic: PropTypes.object,
  actions: PropTypes.shape({
    deleteAnalytic: PropTypes.func.isRequired,
    closeDialog: PropTypes.func.isRequired,
  }),
};


export {
  AnalyticDeleteDialog,
};
